"use client";

import dynamic from "next/dynamic";

const StudioEditorDemo = dynamic(() => import("./StudioEditorDemo").then(mod => mod.StudioEditorDemo));
const VoiceChangerPanDemo = dynamic(() => import("./VoiceChangerPanDemo").then(mod => mod.VoiceChangerPanDemo));

// Component map for rendering based on template name
const stickyContentComponents: Record<string, React.ComponentType> = {
  voiceChangerPanLeft: () => <VoiceChangerPanDemo defaultView='left' />,
  voiceChangerPanRight: () => <VoiceChangerPanDemo defaultView='right' />,
  studioEditor: () => <StudioEditorDemo />,
};

export type StickyContentComponentName = keyof typeof stickyContentComponents;

interface ComponentRendererProps {
  name: StickyContentComponentName;
}

export function ComponentRenderer({ name }: ComponentRendererProps) {
  const Component = stickyContentComponents[name];
  if (!Component) return null;
  return <Component />;
}
